import Model, { attr } from '@ember-data/model';
import { apiAction } from '@mainmatter/ember-api-actions';

export enum SummaryAttributeState {
  Review = 'review',
  Denied = 'denied',
}

class SummaryAttribute extends Model {
  @attr('string') declare state?: SummaryAttributeState | null;

  @attr('string', { defaultValue: 'none' }) declare kind: string;
  @attr('string') declare videoUrl?: string | null;
  @attr('string') declare message?: string | null;
  @attr('string') declare messageHtml?: string | null;
  @attr('string') declare defaultMessage?: string | null;
  @attr('string') declare image?: string | null;
  @attr('immutable', {
    defaultValue: function () {
      return { message: {} };
    },
  })
  declare customTranslations: {
    message: Record<string, string>;
  };

  async deleteSummaryPhoto(): Promise<{ data: Record<string, unknown> }> {
    return await apiAction(this, { method: 'DELETE', path: 'attachments/image' });
  }
}

export default SummaryAttribute;

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'summary-attribute': SummaryAttribute;
  }
}
